export const formatConversionFactor = (value) => {
  if (value === null || value === undefined || value === '') return '';

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return value;

  const [integerPart, decimalPart = ''] = numericValue.toFixed(4).split('.');
  const decimals = decimalPart.replace(/0+$/, '').padEnd(2, '0');

  return `${integerPart}.${decimals}`;
};
